// Saves a blob response (axios, responseType "blob") as a file, using the server's file name when it sends one.
export const fileNameFrom = (headers, fallback) => {
    const disposition = (headers && (headers['content-disposition'] || headers['Content-Disposition'])) || ''
    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition)
    return match ? decodeURIComponent(match[1]) : fallback
}

export const saveBlobResponse = (res, fallbackName, type = 'application/pdf') => {
    const file = new Blob([res.data], { type })
    const url = window.URL.createObjectURL(file)
    const link = document.createElement('a')
    link.href = url
    link.download = fileNameFrom(res.headers, fallbackName)
    document.body.appendChild(link)
    link.click()
    link.remove()
    setTimeout(() => window.URL.revokeObjectURL(url), 1000)
}
